export default __webpack_public_path__ + "images/like-icon.4a3ba987d57900b648906f48077381b7.svg";